import { useEffect, useState } from "react";
import useShoppingCart from "../../../../hooks/useShoppingCart.hook";
import { orderModel } from "../../../../models/orders/order.model";
import { addressModel } from "../../../../models/orders/address..model";
import { objectsHelper } from "../../../../helpers/objects.helper";
import shoppingCartHelper from "../../../../helpers/shoppingCart.helper";
import useWebsiteConfiguration from "../../../../hooks/websiteConfigurations/useWebsiteConfiguration";
import { websiteConfigurationEnum } from "../../../../enums/websiteConfigurations/websiteConfiguration.enum";
import CheckoutOrderDetailsComponent from "../checkoutOrderDetails/CheckoutOrderDetailsComponent";
import CheckoutOrderSummaryComponent from "../checkoutOrderSummary/CheckoutOrderSummaryComponent";

import "./checkoutPageComponent.scss";
import { useDispatch } from "react-redux";
import orderActions from "../../../../store/actions/orders/order.actions";
import AlertService from "../../../../services/alerts/alert.service";

export const CheckoutPageComponent = () => {
  const dispatch = useDispatch();
  const { cartItems, addItem, removeItem, updateItemQuantity, clearCartItems } = useShoppingCart();

  const [orderDetails, setOrderDetails] = useState(orderModel);
  const [paymentAddressTypesOptions, setPaymentAddressTypesOptions] = useState([]);
  const [selectedPaymentAddressOption, setSelectedPaymentAddressOption] = useState(1);

  const { configurationValue: deliveryOptions } = useWebsiteConfiguration(websiteConfigurationEnum.DeliveryOptions);

  useEffect(() => {
    if (cartItems) setOrderDetails({ ...orderDetails, orderItems: cartItems });
  }, [cartItems]);

  useEffect(() => {
    if (deliveryOptions?.length > 0) {
      setOrderDetails((prevOrderDetails) => ({
        ...prevOrderDetails,
        deliveryType: deliveryOptions[0]?.id, // Set first delivery option
        totalAmount: calculateTotalPrice(), // Calculate initial total amount
      }));
    }
  }, [deliveryOptions]);

  useEffect(() => {
    setOrderDetails((prevOrderDetails) => ({
      ...prevOrderDetails,
      totalAmount: calculateTotalPrice(),
    }));
  }, [orderDetails.orderItems, orderDetails.deliveryType]);

  // handle change functions
  const handleChangeOrderDetails = (event) => {
    const { name, value } = event.target;
    const numberProperties = ["totalAmount"]; // cast to number those properties
    if (numberProperties.includes(name)) setOrderDetails({ ...orderDetails, [name]: +value });
    else if (name === "paymentAddressType") {
      setSelectedPaymentAddressOption(+value);
      if (+value === 1) setOrderDetails({ ...orderDetails, billingAddress: null });
      else setOrderDetails({ ...orderDetails, billingAddress: { ...addressModel } });
    } else setOrderDetails({ ...orderDetails, [name]: value });
  };

  const handleDeliveryAddressChange = (event) => {
    const { name, value } = event.target;
    if (objectsHelper.hasProperty(orderDetails.client, name)) {
      setOrderDetails({ ...orderDetails, client: { ...orderDetails.client, [name]: value } });
    } else {
      setOrderDetails({ ...orderDetails, shippingAddress: { ...orderDetails.shippingAddress, [name]: value } });
    }
  };

  const handlePaymentAddressChange = (event) => {
    const { name, value } = event.target;
    if (objectsHelper.hasProperty(orderDetails.billingAddress.personalDetails, name)) {
      setOrderDetails({ ...orderDetails, billingAddress: { ...orderDetails.billingAddress, personalDetails: { ...orderDetails.billingAddress.personalDetails, [name]: value } } });
    } else {
      setOrderDetails({ ...orderDetails, billingAddress: { ...orderDetails.billingAddress, [name]: value } });
    }
  };

  const calculateDeliveryCost = () => {
    const deliveryDetails = deliveryOptions?.find((option) => option.id === orderDetails.deliveryType);
    return deliveryDetails ? deliveryDetails?.price : 0;
  };

  const calculateTotalPrice = () => {
    const totalCartItemsPrice = +shoppingCartHelper.calculateTotalPrice(orderDetails.orderItems);
    const totalDeliveryPrice = calculateDeliveryCost();
    return +totalCartItemsPrice + +totalDeliveryPrice;
  };

  // ***********************
  const handleValidateDiscountCouponClicked = (event) => {
    event.preventDefault();
  };

  const handlePaymentButtonClicked = async (event) => {
    event.preventDefault();
    try {
      const request = { ...orderDetails, deliveryCost: calculateDeliveryCost(), totalAmount: calculateTotalPrice() };
      const createPaymentPageResponse = await dispatch(orderActions.addOrder(request));
      if (createPaymentPageResponse?.statusCode === 200 && createPaymentPageResponse?.payload?.paymentPageIrl) {
        clearCartItems();
        window.location.href = createPaymentPageResponse.payload.paymentPageIrl;
      }
    } catch (error) {
      AlertService.error("שגיאה בביצוע הזמנה", "אנא נסה שנית מאוחר יותר");
    }
  };

  // get elements functions
  const getCheckoutOrderDetailsElement = () => {
    const elementProps = { orderDetails, paymentAddressTypesOptions, selectedPaymentAddressOption };
    elementProps.functions = { handleChangeOrderDetails, handleDeliveryAddressChange, handlePaymentAddressChange };
    return <CheckoutOrderDetailsComponent props={elementProps} />;
  };

  const getCheckoutOrderSummaryElement = () => {
    const elementProps = { orderDetails };
    elementProps.functions = { handleChangeOrderDetails, handlePaymentButtonClicked, handleValidateDiscountCouponClicked, calculateTotalPrice, calculateDeliveryCost };
    return <CheckoutOrderSummaryComponent props={elementProps} />;
  };
  // ***********************

  return (
    <div className="checkoutPageContainer container containerPadd">
      <div className="checkoutHeaderContainer">
        <h1>תשלום</h1>
      </div>

      <div className="checkoutContentContainer">
        {getCheckoutOrderDetailsElement()}
        {getCheckoutOrderSummaryElement()}
      </div>
    </div>
  );
};

export default CheckoutPageComponent;
